import {createAsyncThunk} from '@reduxjs/toolkit';
import api, {CustomAxiosConfig} from 'services/axios';

import {
  ConfirmExtraDeliveryInput,
  ConfirmExtraDeliveryResponse,
  CreateExtraDeliveryPreorderInput,
  CreateExtraDeliveryPreorderResponse,
  DeleteExtraDeliveryInput,
  DeleteExtraDeliveryResponse,
  GetExtraDeliveryDetailInput,
  GetExtraDeliveryDetailResponse,
  GetExtraDeliveryListInput,
  GetExtraDeliveryListResponse,
  GetExtraDeliveryPlansInput,
  GetExtraDeliveryPlansResponse,
  PauseExtraDeliveryInput,
  PauseExtraDeliveryResponse
} from './types';

export const getExtraDeliveryList = createAsyncThunk<
  GetExtraDeliveryListResponse,
  GetExtraDeliveryListInput
>('extraDelivery/getExtraDeliveryList', async (params, thunkApi) => {
  try {
    const response = await api.get(`/dasht/extra-delivery/`, {
      params,
      goBaseUrl: true
    } as CustomAxiosConfig);
    return thunkApi.fulfillWithValue(response.data?.data);
  } catch (error: any) {
    return thunkApi.rejectWithValue(error);
  }
});

export const createExtraDeliveryPreorder = createAsyncThunk<
  CreateExtraDeliveryPreorderResponse,
  CreateExtraDeliveryPreorderInput
>('extraDelivery/createExtraDeliveryPreorder', async (input, thunkApi) => {
  try {
    const body = {
      start_date: input.start_date,
      polygon_ids: input.polygon_ids
    };
    const response = await api.post(`/dasht/extra-delivery?vendor_id=${input.vendor_id}`, body, {
      goBaseUrl: true
    } as CustomAxiosConfig);
    return thunkApi.fulfillWithValue(response.data);
  } catch (error: any) {
    return thunkApi.rejectWithValue(error);
  }
});

export const getExtraDeliveryPlans = createAsyncThunk<
  GetExtraDeliveryPlansResponse,
  GetExtraDeliveryPlansInput
>('extraDelivery/getExtraDeliveryPlans', async (input, thunkApi) => {
  try {
    const response = await api.get(`/dasht/extra-delivery/plans?vendor_id=${input.vendor_id}`, {
      goBaseUrl: true
    } as CustomAxiosConfig);
    return thunkApi.fulfillWithValue(response.data);
  } catch (error: any) {
    return thunkApi.rejectWithValue(error);
  }
});

export const confirmExtraDelivery = createAsyncThunk<
  ConfirmExtraDeliveryResponse,
  ConfirmExtraDeliveryInput
>('extraDelivery/confirmExtraDelivery', async (input, thunkApi) => {
  try {
    const body = {code: input.code};
    const response = await api.put(
      `/dasht/extra-delivery/confirm?vendor_id=${input.vendor_id}`,
      body,
      {
        goBaseUrl: true
      } as CustomAxiosConfig
    );
    return thunkApi.fulfillWithValue(response.data?.data);
  } catch (error: any) {
    return thunkApi.rejectWithValue(error);
  }
});

export const getExtraDeliveryDetail = createAsyncThunk<
  GetExtraDeliveryDetailResponse,
  GetExtraDeliveryDetailInput
>('extraDelivery/getExtraDeliveryDetail', async (input, thunkApi) => {
  try {
    const response = await api.get(`/dasht/extra-delivery/${input.id}`, {
      params: {vendor_id: input.vendor_id},
      goBaseUrl: true
    } as CustomAxiosConfig);
    return thunkApi.fulfillWithValue(response.data);
  } catch (error: any) {
    return thunkApi.rejectWithValue(error);
  }
});

export const deleteExtraDelivery = createAsyncThunk<
  DeleteExtraDeliveryResponse,
  DeleteExtraDeliveryInput
>('extraDelivery/deleteExtraDelivery', async (input, thunkApi) => {
  try {
    const response = await api.delete(`/dasht/extra-delivery/${input.id}`, {
      params: {vendor_id: input.vendor_id},
      goBaseUrl: true
    } as CustomAxiosConfig);
    return thunkApi.fulfillWithValue(response.data);
  } catch (error: any) {
    return thunkApi.rejectWithValue(error);
  }
});

export const pauseExtraDelivery = createAsyncThunk<
  PauseExtraDeliveryResponse,
  PauseExtraDeliveryInput
>('extraDelivery/pauseExtraDelivery', async (input, thunkApi) => {
  try {
    const response = await api.put(
      `/dasht/extra-delivery/${input.id}/pause`,
      {pause: input.pause},
      {
        params: {vendor_id: input.vendor_id},
        goBaseUrl: true
      } as CustomAxiosConfig
    );
    return thunkApi.fulfillWithValue(response.data);
  } catch (error: any) {
    return thunkApi.rejectWithValue(error);
  }
});
